import { createSlice } from "@reduxjs/toolkit";
import { AUTHENTICATED, UNAUTHENTICATED } from "../../../constants";

const initialState = {
  user: {
    authState: JSON.parse(localStorage.getItem("token"))
      ? AUTHENTICATED
      : UNAUTHENTICATED,
    role:
      JSON.parse(localStorage.getItem("loggedInUserGroups") || "[]")[0] || "",
    attributes: JSON.parse(localStorage.getItem("attributes")) || null,
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthenticatedUser: (state, action) => {
      state.user.authState = action.payload.authState;
      state.user.role = action.payload.role;
      state.user.attributes = action.payload.attributes;
    },
    setAuthLoading: (state, action) => {
      state.user.authState = action.payload;
    },
  },
});

export const { setAuthenticatedUser, setAuthLoading } = authSlice.actions;
export default authSlice.reducer;
